import { render, staticRenderFns } from "./extensionNew.vue?vue&type=template&id=32335535&scoped=true&"
import script from "./extensionNew.vue?vue&type=script&lang=js&"
export * from "./extensionNew.vue?vue&type=script&lang=js&"
import style0 from "./extensionNew.vue?vue&type=style&index=0&id=32335535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32335535",
  null
  
)

export default component.exports